const normalizeMonthToken = value => {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z]/g, '');
};

const createMonthNameLookup = () => {
  const locales = ['en', 'en-US', 'en-GB', 'nb', 'nb-NO', 'no', 'sv', 'da', 'de'];
  const map = new Map();
  const addName = (name, monthIndex) => {
    const token = normalizeMonthToken(name);
    if (!token) return;
    if (!map.has(token)) {
      map.set(token, monthIndex);
    }
  };
  for (let month = 0; month < 12; month += 1) {
    const date = new Date(Date.UTC(2020, month, 1));
    locales.forEach(locale => {
      try {
        addName(new Intl.DateTimeFormat(locale, { month: 'long' }).format(date), month + 1);
        addName(new Intl.DateTimeFormat(locale, { month: 'short' }).format(date), month + 1);
      } catch (err) {
        // ignore locale issues
      }
    });
  }
  map.set('sept', 9);
  map.set('sep', 9);
  return map;
};

const MONTH_NAME_LOOKUP = createMonthNameLookup();

const coerceYearMonth = value => {
  if (value == null) return null;
  const text = String(value).trim();
  if (!text) return null;
  const isoMatch = text.match(/^(\d{4})[-_/](\d{1,2})$/);
  if (isoMatch) {
    const year = isoMatch[1];
    const month = isoMatch[2].padStart(2, '0');
    const numericMonth = Number(month);
    if (numericMonth >= 1 && numericMonth <= 12) {
      return `${year}-${month}`;
    }
  }
  const cleaned = text
    .replace(/[.,]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!cleaned) return null;
  const tokens = cleaned
    .split(' ')
    .flatMap(token => {
      if (/\d{4}/.test(token) && /[a-zA-Z]/.test(token)) {
        return token.replace(/(\d{4})/, ' $1 ').split(' ').filter(Boolean);
      }
      return [token];
    });
  let year = null;
  let month = null;
  tokens.forEach(token => {
    const trimmed = token.trim();
    if (/^\d{4}$/.test(trimmed)) {
      year = trimmed;
      return;
    }
    const normalizedToken = normalizeMonthToken(trimmed);
    if (normalizedToken && MONTH_NAME_LOOKUP.has(normalizedToken)) {
      month = String(MONTH_NAME_LOOKUP.get(normalizedToken)).padStart(2, '0');
      return;
    }
  });
  if (year && month) {
    return `${year}-${month}`;
  }
  return null;
};

const normalizeMonth = (value, fallback) => {
  const coerced = coerceYearMonth(value);
  if (coerced) return coerced;
  return fallback || null;
};

export { coerceYearMonth, normalizeMonth };
